import React, { memo } from 'react';
import styled from 'styled-components';

import Avatar, { IAvatar } from '../../Clients/Avatar';
import Button from '../../../Button';

import { TICKET_LOG_TYPES as TYPES } from '../../../../constants';

import {
  Bot as BotIcon,
  System,
  User,
  Task,
  Debug,
  SystemAuto,
  SystemView,
  SystemChange,
  SystemDispatch,
  UserRating,
  TourSelection,
  UserCreationAction,
} from '@icons/communication';
import { ValueOf } from '@utils/tsUtils';

interface ITicketLogIconButton {
  className?: string;
  avatarUrl?: IAvatar['url'];
  value?: string | null;
  type: ValueOf<typeof TYPES>;
  onClick: () => void;
}

const TicketLogIconButton = ({
  className,
  avatarUrl = null,
  type,
  value = null,
  onClick,
}: ITicketLogIconButton) => (
  <StyledIconButton className={className} functional onClick={onClick}>
    <StyledIcon avatarUrl={avatarUrl} type={type} value={value} />
  </StyledIconButton>
);

const StyledIconButton = styled(Button)`
  width: 16px;
  height: 16px;
  min-height: 16px;
`;

const StyledAvatar = styled(Avatar)`
  width: 100%;
  height: 100%;
`;

const StyledIcon = styled(({ avatarUrl, type, value, ...props }) => {
  let Icon;
  switch (type) {
    case TYPES.TASK:
    case TYPES.NOTE:
      Icon = <StyledAvatar url={avatarUrl} />;
      break;

    case TYPES.SYSTEM:
      Icon = <System width={14} height={14} />;
      break;

    case TYPES.USER:
      Icon = <User width={14} height={14} />;
      break;

    case TYPES.TASK:
      Icon = <Task width={14} height={14} />;
      break;

    case TYPES.DEBUG:
      Icon = <Debug width={14} height={14} />;
      break;

    case TYPES.SYSTEM_AUTO:
      Icon = <SystemAuto width={14} height={14} />;
      break;

    case TYPES.SYSTEM_VIEW:
      Icon = <SystemView width={14} height={14} />;
      break;

    case TYPES.SYSTEM_CHANGE:
      Icon = <SystemChange width={14} height={14} />;
      break;

    case TYPES.SYSTEM_DISPATCH:
      Icon = <SystemDispatch width={14} height={14} />;
      break;

    case TYPES.USER_RATING:
      Icon = <UserRating width={14} height={14} />;
      break;

    case TYPES.TOUR_SELECTION:
      Icon = <TourSelection width={14} height={14} />;
      break;

    case TYPES.USER_CREATION_ACTION:
      Icon = <UserCreationAction width={14} height={14} />;
      break;

    default:
      Icon = <BotIcon />;
      break;
  }

  return React.cloneElement(Icon, props);
})``;

export default memo(TicketLogIconButton);
